import { useMemo } from "react";
import { useSelector } from "react-redux";

import { isNullOrWhiteSpace } from "Utils/String";
import { IProject } from "Model/Storage/IProject";
import { selectSelectedProjects } from "Store/Selectors/Projects";

export function useProject(projectId: string): IProject {
  const projects = useSelector(selectSelectedProjects);

  return useMemo(() => {
    if (isNullOrWhiteSpace(projectId)) {
      return null;
    }

    return projects.find((p) => p[`@id`] === projectId);
  }, [projectId, projects]);
}
